import { createGlobalStyle } from 'styled-components';
import Intents from '@ux/intents';

export const intents = new Intents();

const WhiteBackgroundGlobalStyle = createGlobalStyle`
  /* stylelint-disable-next-line selector-disallowed-list -- so far we don't have access to the body */
  .ux-app {
    background: ${intents.ux.box.backgroundColor};
  }
`;

export default WhiteBackgroundGlobalStyle;
